import { FC, ReactNode } from 'react'
import { Location } from '../../../../api/models'
import { AgencyTypeValues } from '../../../../constants/AgencyType'
import { ActionFunctions, PermitColumnEditor } from './PermitColumnEditor'
import { PermitColumnViewer } from './PermitColumnViewer'

interface PermitColumnProps {
  agencyType: AgencyTypeValues
  location: Location
  col: number
  editingAgencyType: AgencyTypeValues | null
  onEditClicked: () => void
  emitFunctions: (actionFunctions: ActionFunctions) => void
  actionButtons?: ReactNode
  onCloseEditors: () => void
}

export const PermitColumn: FC<PermitColumnProps> = ({
  agencyType,
  location,
  col,
  editingAgencyType,
  onEditClicked,
  emitFunctions,
  actionButtons,
  onCloseEditors
}) => {
  const permit = location.permits ? location.permits[agencyType] : undefined

  if (editingAgencyType === agencyType) {
    return (
      <PermitColumnEditor
        location={location}
        agencyType={agencyType}
        permit={permit}
        emitFunctions={emitFunctions}
        actionButtons={actionButtons}
        col={col}
        onOperationSuccess={() => {
          onCloseEditors()
        }}
      />
    )
  } else {
    return (
      <PermitColumnViewer
        agencyType={agencyType}
        location={location}
        col={col}
        editingAgencyType={editingAgencyType}
        onEditClicked={onEditClicked}
        actionButtons={actionButtons}
      />
    )
  }
}
